<div class="modal-window__header">
  <div class="modal-window__title">{{ "location.edittitle" | translate }}</div>
  <a (click)="onCancel()">
    <i class="c-icon c-icon--close-dark"></i>
  </a>
</div>
<form
  #f="ngForm"
  id="modal-form"
  (ngSubmit)="onEditLocation()"
  class="o-grid--medium u-mt--medium">
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label
      for="locationName"
      class="c-form-label"
      >{{ "location.name" | translate }}</label
    >
    <input
      id="locationName"
      name="locationName"
      [(ngModel)]="location.locationName"
      class="c-input c-input--alpha c-not-allowed"
      readonly="true" />
  </div>
  <div class="c-form-group o-grid__item col-12 col-sm-12">
    <label
      for="locationDescription"
      class="c-form-label"
      >{{ "location.description" | translate }}</label
    >
    <input
      id="locationDescription"
      name="locationDescription"
      [(ngModel)]="location.locationDescription"
      class="c-input c-input--alpha" />
  </div>
  <div class="o-grid__item col-offset-6 col-3 u-mt--medium u-tablet">
    <button
      type="button"
      (click)="onCancel()"
      class="button--sm button-secondary button-block">
      {{ "button.cancel" | translate }}
    </button>
  </div>
  <div class="o-grid__item col-12 col-md-3 u-mt--medium">
    <button
      type="submit"
      class="button--sm button-primary button-block"
      [disabled]="f.invalid">
      {{ "button.save" | translate }}
    </button>
  </div>
</form>
